import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import SliderRating from '../../components/SliderRating';
import RadioView from '../../components/RadioView';
import {ServiceData} from '../../assets/Data.js';
import FloatTextField from '../../components/FloatTextField';
import design from '../../assets/design.png';

const Service2 = (props) => {
  const {t} = useTranslation();
  const { formData={}, setFormData , onPageIndex} = props;
  const [isFormValid, setFormValid] = useState(true);
  const [isError, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({...formData, feedback_details: {...formData.feedback_details, [e.target.name] : e.target.value}});
  }
  
  const {
    f_goldexchangeservice = "",
    servicecomments = "",
  } = formData.feedback_details;

  return (
    <>
      <div className="bg-light rounded px-3 py-2 bg-white-color my-3">
        <SliderRating icon={design} indexVal="03" label={t(ServiceData.fields[2].title)} name="f_goldexchangeservice" value={f_goldexchangeservice} onInputChange={(e) => handleChange(e)} />
      </div>

      <div className="py-3 rounded px-3">
          <div>
            <FloatTextField label={t("service_any_other_comments")} value={servicecomments} name="servicecomments"  onInputChange={(e) => handleChange(e)} />
          </div>
      </div>
	  </>
  );
}

export default Service2;